import { Component, OnInit } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';

@Component({
    selector: 'app-disclaimer',
    templateUrl: './disclaimer.component.html',
    styleUrls: ['./disclaimer.component.scss'],
    imports: [IonicModule]
})
export class DisclaimerComponent {
  constructor(private _modalController: ModalController) {}

  close(): void {
    this._modalController.dismiss();
  }
}
